export const getFormattedLanguage = (title: string) => {
  switch (title) {
    case "en":
      return "English"
    case "da":
      return "Dansk"
    case "no":
      return "Norsk"
    case "is":
      return "íslenskur"
    default:
      return title
  }
}
